import type { ThemeType } from 'common/types/Styles';

export const POSITIVE_AMOUNT_INDICATOR_ICON = (_: { theme: ThemeType }) => 'arrow-up';
export const NEGATIVE_AMOUNT_INDICATOR_ICON = (_: { theme: ThemeType }) => 'arrow-down';
export const EQUAL_AMOUNT_INDICATOR_ICON = (_: { theme: ThemeType }) => undefined;
